import { render, staticRenderFns } from "./ProjectReports.vue?vue&type=template&id=1a316d56&"
import script from "./ProjectReports.vue?vue&type=script&lang=js&"
export * from "./ProjectReports.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports